import CurrencySetup from './currency_setup';

export const getCurrencySetup = currencyIsoCode =>
    CurrencySetup[currencyIsoCode] || CurrencySetup.defaultSetup;
